<template>
  <b-container fluid class="text-image-ribbon">
    <b-row class="my-5" align-h="center">
      <b-col cols="10" lg="6">
        <div v-html="sanitizedContent(text)"></div>
      </b-col>
			<b-col cols="10" lg="4">
        <img class="rib-img" :src="imageSrc" alt="Ribbon Image" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
		text: String,
    image: Object
  },
	computed: {
    imageSrc() {
      return `/strapi/${this.image.data.attributes.url}`
    }
	},
  methods: {
    sanitizedContent(content) {
      return DOMPurify.sanitize(marked(content))
    }
  }
}
</script>

<style scoped src="@/assets/css/text-image-ribbon.css"/>
